<template>
    <div class="admin-dashboard">
        <div class="admin-dashboard__wrapper">
            <div class="admin-dashboard__tab-wrapper">
                <v-tabs v-model="tab" :bg-color="primary800" show-arrows center-active>
                    <v-tab :id="DASHBOARD_SLUG_WAREHOUSE" :value="DASHBOARD_SLUG_WAREHOUSE">{{ $t('dashboard.warehouseList') }}</v-tab>
                    <v-tab v-if="!isAdminWholesaler" :id="DASHBOARD_SLUG_SALES_REP" :value="DASHBOARD_SLUG_SALES_REP">{{ $t('dashboard.salesRepList') }}</v-tab>
                    <v-tab v-if="!isAdminWholesaler && !isPhReg" :id="DASHBOARD_SLUG_SALES_REP_REG" :value="DASHBOARD_SLUG_SALES_REP_REG">{{ $t('dashboard.salesRepRegList') }}</v-tab>
                </v-tabs>
            </div>
            <div class="admin-dashboard__top-btn-wrapper">
                <KButton
                    id="add-modal"
                    :label="tab === DASHBOARD_SLUG_WAREHOUSE && !isAdminWholesaler ? $t('dashboard.addWarehouse') : tab === DASHBOARD_SLUG_SALES_REP || isAdminWholesaler ? $t('dashboard.addNewSalesRep') : $t('dashboard.addRKS')"
                    icon="arrowRight"
                    secondary
                    uppercase
                    @click="tab === DASHBOARD_SLUG_WAREHOUSE && !isAdminWholesaler ? navigateTo('/warehouse/create') : tab === DASHBOARD_SLUG_SALES_REP || isAdminWholesaler ? navigateTo('/sales-rep/create') : navigateTo('/sales-rep/create-rks')"
                />
            </div>
        </div>

        <v-window v-model="tab">
            <v-window-item :value="DASHBOARD_SLUG_WAREHOUSE">
                <WarehouseTable />
            </v-window-item>
            <v-window-item :value="DASHBOARD_SLUG_SALES_REP">
                <SalesRepTable />
            </v-window-item>
            <v-window-item :value="DASHBOARD_SLUG_SALES_REP_REG">
                <SalesRepTable is-sales-rep-reg />
            </v-window-item>
        </v-window>
    </div>
</template>

<script setup lang="ts">
import { ref } from '@vue/runtime-core';
import variables from '@/assets/scss/modules/variables.module.scss';
import { storeToRefs } from 'pinia';
import { useUserStore } from '@/stores/user';
import {
    DASHBOARD_SLUG_WAREHOUSE,
    DASHBOARD_SLUG_SALES_REP,
    DASHBOARD_SLUG_SALES_REP_REG
} from '@/hooks/DashboardHooks';
import { navigateTo } from '@/hooks/NavigateHooks';
import KButton from '@/components/atoms/KButton.vue';
import WarehouseTable from '@/views/Dashboard/components/WarehouseTable.vue';
import SalesRepTable from '@/components/organisms/SalesRep/SalesRepTable.vue';

const { isPhReg, isAdminWholesaler } = storeToRefs(useUserStore());

const { primary800 } = variables;

const tab = ref<string>(DASHBOARD_SLUG_WAREHOUSE);
</script>

<style scoped lang="scss">
.admin-dashboard {
    margin-top: 105px;

    &__wrapper {
        @include media-breakpoint-up(md) {
            display: flex;
            align-items: center;
            width: 100%;
        }
    }

    &__tab-wrapper {
        @include media-breakpoint-up(sm) {
            width: max-content;
        }

        &:deep(.v-btn__content) {
            letter-spacing: 0;
            text-transform: uppercase;
        }
        &:deep(.v-btn--size-default) {
            padding: 0 35px;
        }
        &:deep(.v-slide-group__content) {
            justify-content: center;
        }
        &:deep(.v-tab--selected .v-tab__slider) {
            opacity: 1;
            background-color: $secondary-400;
        }
        &:deep(.v-btn) {
            background-color: rgba($black, 0.65);
        }
        &:deep(.v-tab--selected) {
            opacity: 1;
            background-color: $primary-800;
        }
        &:deep(.v-slide-group__next) {
            background-color: $primary-400;
        }
        &:deep(.v-slide-group__prev) {
            background-color: $primary-400;
        }
    }

    &__top-btn-wrapper {
        margin-top: 10px;
        margin-bottom: 10px;

        @include media-breakpoint-up(md) {
            margin-top: 0;
            margin-bottom: 0;
            margin-left: auto;
        }
    }
}
</style>
